import React, { useCallback, useContext, useState } from 'react';
import { ModalTransition } from '@atlaskit/modal-dialog';
import Tooltip from 'components/Tooltip';
import ContactUsFormContainer from 'components/ContactUsForm';
import AnalyticsContext from 'contexts/AnalyticsContext';

import Icon from 'kingpin/atoms/Icon';
import PopUpMenu from 'kingpin/atoms/PopUpMenu';
import Typography from 'kingpin/atoms/Typography';

import NavIconItem from './NavIconItem';
import NavMenuPopup from '../Standard/TopBar/Left/NavMenuPopup';

const HelpMenu = ({
  close,
  openContactPopup,
}: {
  close: () => void;
  openContactPopup: () => void;
}) => {
  const { trackEvent } = useContext(AnalyticsContext);

  const onHelpClicked = useCallback(() => {
    window.open('https://help.fleetops.com/', '_blank');
    trackEvent('Help - Contact Form Opened');
    close();
  }, [close, trackEvent]);

  const onContactSupportClicked = useCallback(() => {
    openContactPopup();
    close();
  }, [close, openContactPopup]);

  return (
    <NavMenuPopup.PopupDiv>
      <NavMenuPopup.ItemDiv onClick={onHelpClicked}>
        <Icon icon={'open-link'} />
        <Typography.Body type={'Label 14'}>Help Center</Typography.Body>
      </NavMenuPopup.ItemDiv>
      <NavMenuPopup.ItemDiv onClick={onContactSupportClicked}>
        <Icon icon={'mail'} />
        <Typography.Body type={'Label 14'}>Contact Support</Typography.Body>
      </NavMenuPopup.ItemDiv>
    </NavMenuPopup.PopupDiv>
  );
};

const Help = () => {
  const [contactUsIsOpen, setContactUsIsOpen] = useState<boolean>(false);
  const openContactPopup = useCallback(() => {
    setContactUsIsOpen(true);
  }, []);
  const closeContactPopup = useCallback(() => {
    setContactUsIsOpen(false);
  }, []);

  return (
    <>
      <PopUpMenu
        trigger={({ isOpen }: { isOpen: boolean }) => (
          <Tooltip content={'Help Center'}>
            <NavIconItem isOpen={isOpen}>
              <Icon
                icon="help"
                color="var(--color-text-secondary)"
                width={19}
                height={19}
              />
            </NavIconItem>
          </Tooltip>
        )}
        children={({ close }) => (
          <HelpMenu close={close} openContactPopup={openContactPopup} />
        )}
        position={'bottom-end'}
      />
      <ModalTransition>
        {contactUsIsOpen && (
          <ContactUsFormContainer close={closeContactPopup} />
        )}
      </ModalTransition>
    </>
  );
};

export default Help;
